/*
 * @Author: Lim 
 * @Date: 2020-09-03 16:32:55 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-10-26 13:26:19
 */
import React, { useState, useEffect, useRef } from 'react';
import style from "./Select.module.scss";
import cn from "classnames";
import { initConfig, unitFilter } from '../common';


export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        list : [{id:1,value:'value01'},{id:2,value:'value02'}],
        defaultId : '',
        canSearch : false,
        titleFlag : false,
        disable : false,
        width : "100%",
        maxHeight : 200,
        check(data){},
        placehoderText : '',
        nodata : '暂无数据',
        blur(){}
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     */
    const { 
        list,
        defaultId, 
        canSearch, 
        titleFlag, 
        disable, 
        width, 
        maxHeight, 
        check, 
        placehoderText, 
        nodata,
        blur 
    } = initConfig( defaultConfig, props.config );

    const defaultWidth = unitFilter ( width );
    const defaultMaxHeight = unitFilter ( maxHeight );
    /**
     * state
     * 列表展开 & 收回
     * 当前选中ID
     * 当前选中的值
     * 检索模式下是否展示input
     * 占位文本
     */
    const [ isOpen, setIsOpen ] = useState(false);
    const [ checkId, setCheckId ] = useState('');
    const [ value, setValue ] = useState('');
    const [ showInput, setShowInput ] = useState(false);
    const [ placeholder, setPlaceholder ] = useState('');
    /**
     * refs
     * 输入框
     * 下拉框
     */
    const inputContainer = useRef();
    const selectContainer = useRef();
    /**
     * subscribe
     * 订阅点击监听
     */
    const _subscribeClick = e => {
        if(selectContainer.current && !selectContainer.current.contains(e.target)) {
            if( Boolean(canSearch) ){
                checkId === '' ?  setShowInput( true ) : setShowInput( false );
                setValue('');
            }
            setIsOpen( false )
        }
    }
    /**
     * didmount & update & unMount
     */
    useEffect(() => {
        if(defaultId !== ''){
            list.forEach((item)=>{
                if(defaultId === item.id){
                    setCheckId( item.id )
                    canSearch ? setPlaceholder(item.value) : setValue(item.value);
                }
            })
            setShowInput( false )
        }else{
            setShowInput( true )
            canSearch ? setPlaceholder( placehoderText ) :  setValue('')
        }
    },[ defaultId, list ])
    useEffect(() =>{
        document.addEventListener("click", _subscribeClick);
        return ()=>{
            document.removeEventListener("click", _subscribeClick);
        }
    },[isOpen])
    /**
     * Func
     * 点击选择
     * 列表展开 & 收回
     * 列表仅展开
     */
    const _chooseLi = ( item ) => {
        if( item.disable === true ) return false;
        setValue( item.value )
        setPlaceholder( item.value );
        setCheckId( item.id )
        setIsOpen( false )
        check( item )
        if( Boolean(canSearch) ){
            setValue( '' )
            setShowInput( false )
        }else{
            setValue( item.value )
        }
    }
    const _toggleList = () => {
        if( Boolean(disable) ) return false;
        if( Boolean(canSearch) ){
            if(isOpen === false){
                setShowInput( true )
                inputContainer.current.focus();
            }else{
                checkId === '' ?  setShowInput( true ) : setShowInput( false );
            }
        }
        setIsOpen(!isOpen)
    }
    const _slideDown = () => {
        if( Boolean(disable) ) return false;
        setIsOpen(true)
        inputContainer.current.focus();
    }
    /**
     * DOM
     */
    const searchDOM =   <div className={ style.value_box }>
                            <span
                                className= { cn(
                                    style.lastCheck,
                                    style.canserch,
                                ) }
                                title = { titleFlag ? placeholder : "" }
                                style={{ display: showInput ? "none" : "block"}}
                                onClick = { _toggleList }
                            >
                                { placeholder }
                            </span>
                            <input type="text" 
                                className = { style.defaultVal }
                                value={ value } 
                                onChange = { ()=>setValue(inputContainer.current.value) } 
                                onClick = { ()=>_slideDown()}
                                onBlur = {() =>blur()}
                                placeholder={ placeholder }
                                ref = { inputContainer }
                                disable = { disable }
                                title = {titleFlag ? value : ""}
                            /> 
                        </div>;
    const defaultDOM =    <div className={ style.value_box }>
                            <span
                                className= { style.lastCheck }
                                onClick = { _toggleList }
                                title = {titleFlag ? value : ""}
                            >
                                { value }
                            </span>
                            {isOpen ? 
                                <span 
                                    className= { style.maskingCheck }
                                    onClick = { _toggleList }
                                    title = { titleFlag ? value : "" }
                                >
                                    <span>{value}</span>
                                </span>
                                :
                            ""}
                            <span 
                                className = { style.defaultVal }
                                onClick = { _toggleList }
                                title = { titleFlag ? value : "" }
                            >
                                {value}
                            </span>
                            <i 
                                className={ cn(
                                    "font_family",
                                    isOpen ? " icon-inputDropDownClose" : "icon-inputDropDownOpen"
                                ) }
                                style={{ fontSize:14 }}
                                onClick = { _toggleList }
                            ></i>
                        </div>;

    return (
        <div 
            className = { cn(
                style.main,
                disable ? style.disableAll : ""
            )}
        >
            <div className = { style.select } style={{ width: defaultWidth }} ref = { selectContainer }>   

                { canSearch ? searchDOM : defaultDOM }

                <ul className = { isOpen? "" :style.hide } style= {{ maxHeight: defaultMaxHeight }}>
                    {
                        list.map((item,key)=>{
                            if( Boolean(canSearch) ){
                                if(value.trim() === ''){
                                    return (
                                        <li 
                                            key={key} 
                                            title = {titleFlag ? (item.hover ? item.hover : item.value) : ""}
                                            className = {  cn(
                                                checkId === item.id ? style.gray : "",
                                                item.disable === true ? style.disable : ""
                                            ) }
                                            onClick = { ()=>_chooseLi(item) } 
                                        >{item.value}</li>
                                    )
                                }
                                else if(item.value.indexOf(value) > -1 ){
                                    const matchColor = `<label style="color:rgb(59, 153, 252);">${value}</label>`;
                                    let matchStr  = item.value.replace(value,matchColor)
                                    return (
                                        <li 
                                            key={key} 
                                            title = {titleFlag ? (item.hover ? item.hover : item.value) : ""}
                                            className = { checkId === item.id ? style.gray : ""}
                                            onClick = { ()=>_chooseLi(item) } 
                                            dangerouslySetInnerHTML={{__html: matchStr}} 
                                        ></li>
                                    )
                                }
                            }else{
                                return(
                                    <li 
                                        key={key} 
                                        title = {titleFlag ?  (item.hover ? item.hover : item.value) : ""}
                                        className = {  cn(
                                            checkId === item.id ? style.gray : "",
                                            item.disable === true ? style.disable : ""
                                        ) }
                                        onClick = { ()=>_chooseLi(item) } 
                                    >{item.value}</li>
                                )
                            }
                        })
                    }
                    <li className={ style.nodata }>{ nodata }</li>  
                </ul>
            </div>
        </div>
    )
}
